// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pStP","delete":"styles_delete__3CA0a","update":"styles_update__1r_EZ","add":"styles_add__KFXj_"};